import { makeStyles } from '@material-ui/core/styles';

const useApprovalWorkflowStyles = makeStyles(() => ({
    container: { padding: '16px 24px' },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        marginBottom: 12,
    },
    typeTabs: { display: 'flex', gap: 8 },
    typeTab: {
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        borderRadius: 8,
        padding: '6px 16px',
        color: '#515f6d',
    },
    typeTabActive: { background: '#eceef8', color: '#43419e' },
    statusTabs: { display: 'flex', gap: 4, marginBottom: 8 },
    tableWrapper: { maxHeight: 'calc(100vh - 300px)' },
    emptyState: { padding: '48px 0', textAlign: 'center', color: '#6b7280' },
    // A request whose last approval attempt failed still sits in Pending and looks normal
    // otherwise — this is the only thing that tells an approver it will fail again.
    errorRow: { background: '#fff6f6' },
    errorText: { color: '#c62828', fontSize: 12, fontWeight: 600 },
    detailLabel: { fontSize: 12, color: '#6b7280', fontWeight: 600 },
    detailValue: { fontSize: 14, color: '#1f2937', marginBottom: 8 },
}));

export default useApprovalWorkflowStyles;
